import '../App.css';
import React, { useState, useEffect } from 'react';
import { MdArrowBackIos } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { profileUpdate } from '../client';
import { moodUpdate } from '../client';

  const MOOD_OPTIONS = [
  '캐주얼', '스트릿', '웜마일', '아메카지', '시티보이', '스포티',
  '러블리', '놈코어', '프레피',
  '고프코어', '댄디', '에스닉', '매니쉬',
  '로맨틱', '레트로', '걸리시', '워크웨어', '페미닌'
];

const BODY_TYPES = ['마른', '슬림', '보통', '통통한', '근육질', '체격있는', '비공개'];

const FALLBACK_IMAGE_URL = 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/tempprofile.png';

function Editprofile() {
  const navigate = useNavigate();

  // 로컬스토리지에서 현재 사용자 정보 가져오기 (임시)
  const savedToken = localStorage.getItem('user');
  const storedUserObject = savedToken ? JSON.parse(savedToken) : {};
  console.log(storedUserObject)

  const [profile, setProfile] = useState({
    thumbnail: storedUserObject.profile.thumbnail || '',
    username: storedUserObject.username || '모디',
    gender: storedUserObject.gender || '',
    height: storedUserObject.profile?.height || null,
    body_type: storedUserObject.profile?.body_type || '마른',
    instagram_username: storedUserObject.profile?.instagram_username || '',
    introduction: storedUserObject.profile?.introduction || '소개를 작성해주세요',
    fashion_sense: storedUserObject.profile?.moods || [],
    average_score: storedUserObject.profile.average_score || '3.93'
  });

  // 각 항목별 수정 모달 상태
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(''); // 'height', 'body', 'insta', 'intro', 'mood', 'photo'
  const [tempValue, setTempValue] = useState('');
  const [tempMoods, setTempMoods] = useState([...profile.fashion_sense]);
    const [file, setFile] = useState(null);

  const goBack = () => navigate(-1);

  const openModal = (type) => {
    setModalType(type);
    if (type === 'height') setTempValue(profile.height);
    if (type === 'body') setTempValue(profile.body_type);
    if (type === 'insta') setTempValue(profile.instagram_username);
    if (type === 'intro') setTempValue(profile.introduction);
    if (type === 'mood') setTempMoods([...profile.fashion_sense]);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalType('');
    setTempValue('');
  };

  const saveChange = () => {
    if (modalType === 'height') setProfile(prev => ({ ...prev, height: tempValue }));
    if (modalType === 'body') setProfile(prev => ({ ...prev, body_type: tempValue }));
    if (modalType === 'insta') setProfile(prev => ({ ...prev, instagram_username: tempValue }));
    if (modalType === 'intro') setProfile(prev => ({ ...prev, introduction: tempValue }));
    if (modalType === 'mood') setProfile(prev => ({ ...prev, fashion_sense: tempMoods }));
    closeModal();
  };


    const saveProfile = async () => {
      const moodre = await moodUpdate(profile.fashion_sense)
      const re = await profileUpdate(profile.height,profile.body_type,file,profile.introduction,null,null,null,profile.instagram_username)
      if(re){
        alert('프로필 설정이 완료되었습니다.');
        navigate('/');
      }
  };

  const toggleMood = (mood) => {
    if (tempMoods.includes(mood)) {
      setTempMoods(tempMoods.filter(m => m !== mood));
    } else if (tempMoods.length < 3) {
      setTempMoods([...tempMoods, mood]);
    }
  };

  const handleImageChange = (e) => {
    const _file = e.target.files[0];
    if (_file) {
      const reader = new FileReader();
      setFile(_file)
      console.log(reader.result)
      reader.onloadend = () => {
              console.log(reader.result)
        setProfile(prev => ({ ...prev, thumbnail: reader.result }));
      };
      reader.readAsDataURL(_file);
    }
  };

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <header style={styles.header}>
        <MdArrowBackIos size={24} onClick={goBack} style={styles.backIcon} />
        <h2 style={styles.title}>프로필 편집</h2>
        <div style={{ width: 24 }} />
      </header>

      <div style={styles.content}>
        {/* 프로필 사진 */}
        <div style={styles.photoSection}>
          <div style={styles.photoWrapper}>
            <img
              src={profile.thumbnail || FALLBACK_IMAGE_URL}
              alt="프로필"
              style={styles.profileImg}
            />
            <label htmlFor="photo-upload" style={styles.cameraIcon}>📷</label>
            <input
              id="photo-upload"
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />
          </div>
        </div>

        {/* 닉네임 */}
        <div style={styles.item}>
          <span style={styles.label}>닉네임</span>
          <span style={styles.value}>{profile.username}</span>
        </div>

        {/* 성별 (수정 불가) */}
        <div style={styles.item}>
          <span style={styles.label}>성별</span>
          <span style={styles.value}>{profile.gender}</span>
        </div>

        {/* 키 */}
        <div style={styles.item} onClick={() => openModal('height')}>
          <span style={styles.label}>키</span>
          <div style={styles.right}>
            <span style={styles.value}>
              {profile.height ? `${profile.height}cm` : '키를 설정해 주세요'}
              
              
              </span>
            <span style={styles.arrow}>›</span>
          </div>
        </div>

        {/* 체형 */}
        <div style={styles.item} onClick={() => openModal('body')}>
          <span style={styles.label}>체형</span>
          <div style={styles.right}>
            <span style={styles.value}>
                            {profile.body_type ? `${profile.body_type}` : '체형을 설정해 주세요'}
              </span>
            <span style={styles.arrow}>›</span>
          </div>
        </div>

        {/* 무드 */}
        <div style={styles.item} onClick={() => openModal('mood')}>
          <span style={styles.label}>무드 선택</span>
          <div style={styles.right}>
            <span style={styles.value}>
              {profile.fashion_sense.length > 0 ? profile.fashion_sense.join(' '): '선택 안 함'}
            </span>
            <span style={styles.arrow}>›</span>
          </div>
        </div>

        {/* 인스타그램 */}
        <div style={styles.item} onClick={() => openModal('insta')}>
          <span style={styles.label}>인스타그램 계정</span>
          <div style={styles.right}>
            <span style={styles.value}>
              {profile.instagram_username ? `@${profile.instagram_username}` : '연동되어 있지 않음'}
            </span>
            <span style={styles.arrow}>›</span>
          </div>
        </div>

        {/* 자기소개 */}
        <div style={styles.item} onClick={() => openModal('intro')}>
          <span style={styles.label}>자기소개</span>
          <div style={styles.right}>
            <span style={{ ...styles.value, color: profile.introduction === '소개를 작성해주세요' ? '#aaa' : '#000' }}>
              {profile.introduction || '소개를 작성해주세요'}
            </span>
            <span style={styles.arrow}>›</span>
          </div>
        </div>


            <button style={styles.followButton} onClick={()=> saveProfile()}>
                        저장
                    </button>

      </div>

      {/* 수정 모달 */}
      {showModal && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <MdArrowBackIos size={20} onClick={closeModal} style={styles.modalClose} />
              
              <h3 style={styles.modalTitle}>
                {modalType === 'height' && '키'}
                {modalType === 'body' && '체형'}
                {modalType === 'insta' && '인스타그램'}
                {modalType === 'intro' && '자기소개'}
                {modalType === 'mood' && '무드 선택'}
              </h3>

              <div></div>
             
            </div>

            <div style={styles.modalBody}>
              {/* 키 입력 */}
              {modalType === 'height' && (
                <input
                  type="number"
                  value={tempValue}
                  onChange={e => setTempValue(e.target.value)}
                  style={styles.textInput}
                  placeholder="키를 입력하세요 (cm)"
                />
              )}

              {/* 체형 입력 */}
              {modalType === 'body' && (
                <div>
                  <p style={{ margin: '0 0 16px', color: '#666', fontSize: '14px', textAlign: 'center' }}>
                    체형을 선택해주세요
                  </p>
                  <div style={styles.bodyTypeGrid}>
                    {BODY_TYPES.map(type => (
                      <button
                        key={type}
                        onClick={() => setTempValue(type)}
                        style={{
                          ...styles.bodyTypeChip,
                          backgroundColor: tempValue === type ? '#ff4d4f' : '#f5f5f5',
                          color: tempValue === type ? 'white' : '#333',
                          border: tempValue === type ? '2px solid #ff4d4f' : '2px solid transparent'
                        }}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* 인스타그램 */}
              {modalType === 'insta' && (
                <input
                  type="text"
                  value={tempValue}
                  onChange={e => setTempValue(e.target.value.replace('@', ''))}
                  style={styles.textInput}
                  placeholder="인스타그램 아이디 (앞에 @ 생략)"
                />
              )}

              {/* 자기소개 */}
              {modalType === 'intro' && (
                <textarea
                  value={tempValue}
                  onChange={e => setTempValue(e.target.value)}
                  style={styles.textarea}
                  rows="4"
                  placeholder="자기소개를 입력하세요"
                />
              )}

              {/* 무드 선택 */}
              {modalType === 'mood' && (
                <div>
                  <h3 style={styles.modalTitle}>
                내가 좋아하는 무드를 1개 이상 선택해주세요
              </h3>
                  <p style={{ margin: '0 0 10px', color: '#ff4d4f', fontSize: '14px' }}>
                    언제든 수정 가능합니다
                  </p>
                  <div style={styles.moodGrid}>
                    {MOOD_OPTIONS.map(mood => (
                      <button
                        key={mood}
                        onClick={() => toggleMood(mood)}
                        style={{
                          ...styles.moodChip,
                          backgroundColor: tempMoods.includes(mood) ? '#ff4d4f' : '#f0f0f0',
                          color: tempMoods.includes(mood) ? 'white' : '#333'
                        }}
                      >
                        {mood}
                      </button>
                    ))}
                  </div>
                </div>
              )}

               <button onClick={saveChange} style={styles.modalSave}>완료</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {

  bodyTypeGrid: {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',  // 2열로 예쁘게
  gap: '12px',
  marginTop: '10px'
},
bodyTypeChip: {
  padding: '14px 20px',
  border: '2px solid transparent',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.2s'
},

      followButton: {
        width: '100%',
        padding: '15px 0',
        backgroundColor: '#ff4d4f', // 이미지의 빨간색
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '18px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },

  container: { maxWidth: '420px', margin: '0 auto', background: '#fff', minHeight: '100vh' },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    maxWidth: '420px',
    margin: '0 auto',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    background: '#fff',
    borderBottom: '1px solid #eee',
    zIndex: 10
  },
  backIcon: { cursor: 'pointer' },
  title: { fontSize: '18px', fontWeight: 'bold' },
  content: {  marginTop:'80px',  padding: '20px' },
  photoSection: { textAlign: 'center', marginBottom: '30px' },
  photoWrapper: { position: 'relative', display: 'inline-block' },
  profileImg: { width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover' },
  cameraIcon: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    background: 'rgba(179, 179, 179, 1)',
    color: 'white',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer'
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 0',
    borderBottom: '1px solid #eee',
    cursor: 'pointer'
  },
  label: { fontSize: '16px', color: '#333' },
  right: { display: 'flex', alignItems: 'center', gap: '8px' },
  value: { fontSize: '16px', color: '#666', textAlign: 'right' },
  arrow: { fontSize: '24px', color: '#ccc' },

  // 모달
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modal: {
    background: '#fff',
    width: '90%',
    maxWidth: '400px',
    borderRadius: '12px',
    overflow: 'hidden'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #eee'
  },
  modalClose: { fontSize: '16px', color: '#666' },
  modalTitle: { fontSize: '17px', fontWeight: 'bold' },
  modalSave: { fontSize: '16px', color: '#ffffffff', fontWeight: 'bold',marginTop:'30px',width:'100%',height:'45px',backgroundColor:'#ff4d4f',border:'none',borderRadius:'10px' },
  modalBody: { padding: '20px'},
  textInput: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '16px'
  },
  textarea: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '16px',
    resize: 'none'
  },
  moodGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px'
  },
  moodChip: {
    padding: '10px',
    border: 'none',
    borderRadius: '20px',
    fontSize: '14px',
    cursor: 'pointer'
  }
};

export default Editprofile;